<template>
  <div class="dialog-pay">
    <el-dialog
      :model-value="visible"
      align-center
      width="480"
      :before-close="handleClose"
    >
      <template #header>
        <div class="my-header">
          <h4 class="px-2 pb-3 text-lg text-[#262626] font-semibold">
            选择支付方式
          </h4>
        </div>
      </template>
      <el-form
        ref="formRef"
        require-asterisk-position="right"
        label-position="top"
        :model="form"
        :rules="formRules"
      >
        <el-form-item prop="payMode" label="支付方式">
          <el-select
            v-model="form.payMode"
            filterable
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(v, idx) in payOptions"
              :key="idx"
              :value="v.value"
              :label="v.label"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="flex justify-end">
          <el-button :loading="saveBtnLoading" @click="handleClose">
            取消
          </el-button>
          <el-button type="primary" :loading="saveBtnLoading" @click="handleSubmit">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { hnInvoiceApplyPayLabel } from '@core/main/types/common';
import { PropType } from 'vue';
import { IHnInvoiceApplyItem, IInvoicePayH5UrlParams } from '@core/main/types/crowd-source/invoice-pay-taxes';
import { queryInvoicePayH5Url } from '@core/main/api/crowd-source/invoice-pay-taxes';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  row: {
    type: Object as PropType<IHnInvoiceApplyItem>,
    default: () => ({}),
  },
});

const emit = defineEmits<{close: []}>();

const saveBtnLoading = ref(false);
const formRef = ref();
const form = ref({} as IInvoicePayH5UrlParams);
const payOptions = ref();

const formRules = ref({
  payMode: [
    {
      required: true,
      message: '请选择支付方式',
    },
  ],
});

function handleSubmit() {
  formRef.value.validate(async (valid) => {
    if (valid) doPay();
  });
}

async function doPay() {
  try {
    const params = {
      id: props.row.id,
      payMode: form.value.payMode,
    };

    const { counterUrl, orderStatus } = await queryInvoicePayH5Url(params);

    if (orderStatus === 0) ElMessage.error('存在历史订单未支付，请处理~');

    window.open(counterUrl, '_blank');

    emit('close');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function handleClose() {
  formRef.value.resetFields();
  for (const key in form.value) {
    form.value[key] = '';
  }
  emit('close');
}

function init() {
  payOptions.value = Object.keys(hnInvoiceApplyPayLabel).map((key) => ({
    label: hnInvoiceApplyPayLabel[key],
    value: key,
  }));
}

watch(
  () => props.visible,
  (val) => {
    if (val) {
      init();
    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.dialog-pay {
  :deep(.el-dialog) {

    .el-select__wrapper {
      height: 40px;
    }

    .el-dialog__header {
      padding-bottom: 24px;
    }
  }
}
</style>